module.exports = __webpack_public_path__ + "static/media/danielflores.dd64e5c3.jpeg";